import { render, staticRenderFns } from "./banner-add-or-update.vue?vue&type=template&id=dbf4e86c&scoped=true&"
import script from "./banner-add-or-update.vue?vue&type=script&lang=js&"
export * from "./banner-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./banner-add-or-update.vue?vue&type=style&index=0&id=dbf4e86c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf4e86c",
  null
  
)

export default component.exports